import React from 'react';
import {
	Dialog,
	DialogContent,
	Grid,
	Typography,
	IconButton as MaterialIconButton,
	Button,
	Checkbox,
	FormControlLabel,
	Select,
	MenuItem,
} from '@mui/material';
import { CloseIcon } from '../assets/icons/Icons';
import IconButton from './IconButton';
import { FEATURE_TYPES, USER_TYPES, WEB_ACCOUNT } from '../Utils/Enums';

function UserControlPopup({
	isModalOpen,
	onClose,
	onClickBtn,
	onSelectItem,
	selectedData,
	selectedUser,
	onChangeUserType,
	accTypeError,
}) {
	function renderDialogContent() {
		return (
			<Grid container paddingX={'15px'}>
				<Typography
					fontSize={'16px'}
					paddingY={'10px'}
					fontWeight={'500'}>
					{`Username: ${selectedUser.name}`}
				</Typography>
				<Grid container flexDirection={'column'} paddingY={'10px'}>
					<Typography
						fontSize={'16px'}
						width={'100%'}
						color={'#7C7C7C'}
						fontWeight={'500'}
						marginBottom={'5px'}>
						User Type
					</Typography>
					<Select
						size="small"
						fullWidth
						value={selectedUser.userType}
						error={accTypeError?.status}
						renderValue={value => {
							if (!value) {
								return (
									<Typography color="#cacdd4">
										Select User Type
									</Typography>
								);
							}
							return value;
						}}
						onChange={e => {
							onChangeUserType(e.target.value);
						}}
						sx={{
							backgroundColor: '#FFFFFF',
							color: '#777E90',
							marginTop: '5px',
						}}>
						{USER_TYPES.map((item, index) => {
							return (
								<MenuItem key={index} value={item.name}>
									{item.name}
								</MenuItem>
							);
						})}
					</Select>
				</Grid>

				<Grid container flexDirection={'column'}>
					<Typography
						fontSize={'16px'}
						width={'100%'}
						color={'#7C7C7C'}
						fontWeight={'500'}
						marginBottom={'5px'}>
						Features
					</Typography>
					<Grid
						container
						paddingLeft={'10px'}
						flexDirection={'column'}>
						{FEATURE_TYPES.map((item, index) => {
							return (
								<FormControlLabel
									key={index}
									label={
										<Typography fontSize={'14px'}>
											{item.name}
										</Typography>
									}
									control={
										<Checkbox
											size="small"
											color="success"
											disableRipple
											onChange={() =>
												onSelectItem(item.key)
											}
											checked={selectedData?.includes(
												item.key,
											)}
										/>
									}
								/>
							);
						})}
					</Grid>
				</Grid>
			</Grid>
		);
	}

	return (
		<>
			<Dialog
				fullWidth
				maxWidth="sm"
				open={isModalOpen}
				onClose={onClose}
				scroll="body">
				<DialogContent style={{ padding: '0px 0px 20px 0px' }}>
					<Grid
						container
						sx={{ boxShadow: 3 }}
						padding={'10px'}
						flexDirection={'row'}
						justifyContent={'space-between'}
						alignItems={'center'}>
						<Typography fontWeight={'600'}>
							Update User Controls
						</Typography>
						<MaterialIconButton
							style={{ padding: '0' }}
							onClick={onClose}>
							<CloseIcon />
						</MaterialIconButton>
					</Grid>
					<Grid container padding={'10px'}>
						{renderDialogContent()}
					</Grid>
					<Grid
						container
						justifyContent={'flex-end'}
						paddingTop={'10px'}
						paddingX={'20px'}>
						<Button
							onClick={onClose}
							sx={{
								border: '2px solid #28696D',
								paddingLeft: '15px',
								paddingRight: '15px',
								color: '#28696D',
								textTransform: 'none',
								marginRight: '10px',
							}}>
							{'Cancel'}
						</Button>
						<IconButton text={'Update'} onClick={onClickBtn} />
					</Grid>
				</DialogContent>
			</Dialog>
		</>
	);
}

export default UserControlPopup;
